module.exports = __webpack_public_path__ + "assets/images/daily_activity_y.87da668a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/daily_activity_y.png
// module id = 697
// module chunks = 1